import styled from 'styled-components';

import { toRem } from '@marriott/mi-ui-library';

type StickyProps = {
  $isSticky: boolean;
  $offset: number;
  $top: number;
  $isClientSideView: boolean;
};

export const StyledStickyComponentWrapper = styled.div<StickyProps>`
  ${(props: StickyProps) => {
    return !props.$isClientSideView
      ? `
        top: ${toRem(52)};
        position: absolute;

      /* Desktop: min-width 768px or higher depending on your breakpoint */
      @media (min-width: 768px) {
          top: ${toRem(88)};
          position: absolute;
      }
    `
      : `top: ${props.$isSticky ? toRem(props.$top) : toRem(props.$offset)};
     position: ${props.$isSticky ? 'fixed' : 'absolute'};`;
  }};

  width: 100vw;
  left: 0;
  ${({ $isSticky, $top }) => ($isSticky && $top !== 0 ? 'transition: top 0.4s ease 0s;' : '')}
  ${({ $isSticky }) => ($isSticky ? 'z-index: 50' : '')};
`;
